export enum Variant {
    Default = 'default',
    Costs = 'costs',
}
